import { render, staticRenderFns } from "./personaJuridicaParticulares.vue?vue&type=template&id=35e87b20"
import script from "./personaJuridicaParticulares.vue?vue&type=script&lang=js"
export * from "./personaJuridicaParticulares.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports